import React from 'react'

const Button = ({ text , ...rest}) => {
    return (
        <button className="text-white bg-indigo-700 hover:bg-indigo-800 focus:ring-4 focus:ring-indigo-300 font-medium rounded-lg text-base px-5 py-2.5 text-center mr-3 mb-3 w-40 font_poppins transform transition duration-300 hover:scale-105 ease-in-out" {...rest}>{text}</button>
    )
}

export default Button
